<aside class="user-nav">
  <mat-accordion>
    <mat-expansion-panel
      [expanded]="localFavoritesPanelOpen"
      class="favourites-section bg-primary"
      (opened)="handleFavoritesPanel('opened')"
      (closed)="handleFavoritesPanel('closed')">
      <mat-expansion-panel-header class="favourites-section-header white-panel-indicator">
        <mat-panel-title class="favourites-title-section">
          <mat-icon [ngStyle]="{ color: !hasFavorites ? '#aaa' : '' }" [color]="hasFavorites ? 'accent' : ''">star</mat-icon>
          <span class="title">{{ "Favorites" | translate }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-favorites />
    </mat-expansion-panel>

    <mat-expansion-panel class="root-header" (opened)="handleSportsPanel('opened')" (closed)="handleSportsPanel('closed')" [expanded]="localSportsPanelOpen">
      <mat-expansion-panel-header class="root-header-section">
        <mat-panel-title class="root-header-title-section">
          <mat-icon class="root-header-icon">menu</mat-icon>
          <a
            [routerLink]="[
              '/app/main',
              {
                outlets: {
                  navigation: ['sports'],
                },
              },
            ]"
            class="root-header-title"
            (click)="stopPropagation($event)"
            >{{ "Sports" | translate }}</a
          >
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="sport-navigation-wrapper">
        <router-outlet></router-outlet>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="nr-links">
    @let nextHorseRace = nextEventsService.titleRace$ | async;
    @let nextGreyhoundRace = nextEventsService.nextGreyhoundRace$ | async;
    @let isLoading = $loading | async;
    <app-nav-item-loader [show]="isLoading && !nextHorseRace && !nextGreyhoundRace" />
    @if (nextHorseRace) {
      <a
        (click)="handleClick()"
        [routerLink]="[
          '/app/main',
          {
            outlets: {
              navigation: ['event', nextHorseRace?.eventId],
              content: ['event-markets', nextHorseRace?.eventId, 'market', nextHorseRace?.id],
            },
          },
        ]"
        class="nr-link horse-race-link bg-primary text-primary-contrast"
        >{{ "Next Horse Race" | translate }}</a
      >
    }
    @if (nextGreyhoundRace) {
      <a
        (click)="handleClick()"
        [routerLink]="[
          '/app/main',
          {
            outlets: {
              navigation: ['event', nextGreyhoundRace?.eventId],
              content: ['event-markets', nextGreyhoundRace?.eventId, 'market', nextGreyhoundRace?.id],
            },
          },
        ]"
        class="nr-link greyhound-link bg-primary text-primary-contrast"
        >{{ "Next Greyhound Race" | translate }}</a
      >
    }
  </div>
</aside>
